import { getDatabase, ref, set } from "firebase/database";
import { useSelector } from 'react-redux';

export const useUserProgramActions = () => {
  // get programCategories from redux here
  const programCategories = useSelector((state) => state.programCategories.categories)
  const userPrograms = useSelector((state) => state.userProgram.userProgram)

  const emailId = useSelector((state) => state.user.emailId)
  const allVideos = useSelector((state) => state.allVideos.videos)
  const adminPrograms = programCategories && programCategories.flatMap((category) => category.adminPrograms)

  var sortedTreeData = []

  function saveUserProgram(uPrograms, doSort = false) {
    var sPrograms = []
    if (!doSort) {
      sPrograms = uPrograms
    } else {
      sortedTreeData.map((item, index) => {
        var foundItem = uPrograms.find((p) => p.id === item.id)
        if (foundItem) {
          var copyItem = { ...foundItem }
          copyItem.idx = index
          sPrograms.push(copyItem)
        }
        return null
      })
    }
    const db = getDatabase();
    set(ref(db, 'VimeoPrograms/' + emailId), { ...sPrograms });
  }

  const addUserProgram = (addedItemId, targetFolder, newTree) => {
    var newUserPrograms = Object.assign([], userPrograms.filter((p) => p.name !== ''))
    sortedTreeData = Object.assign([], newTree)
    Object.setPrototypeOf(newUserPrograms, Array.prototype); // Make the copied array extensible

    function addSingleExercise(exercise, category) {
      const updatedExercise = { ...exercise, splitCategory: category }; // Create a new object with the added property
      if (!newUserPrograms.some((prog) => prog.id === exercise.id && prog.splitCategory === category)) {
        newUserPrograms.push(updatedExercise);
      }
    }

    function isSingleProgramExercise(id) {
      var ex = null
      adminPrograms.forEach((prog, index) => {
        prog.exercises.forEach((exercise, index) => {
          if (exercise.id === id) {
            ex = exercise
          }
        })
      })
      return ex
    }

    var foundItem = null
    if (addedItemId && emailId) {
      // check to see if this is a vimeo video
      foundItem = allVideos && allVideos.find((video) => video.id === addedItemId)
      if (foundItem) {
        addSingleExercise(foundItem, targetFolder)
        saveUserProgram(newUserPrograms, true)
      } else {
        foundItem = isSingleProgramExercise(addedItemId)
        if (foundItem) {
          addSingleExercise(foundItem, targetFolder)
          saveUserProgram(newUserPrograms, true)
        } else {
          programCategories && programCategories.flatMap(category => {
            let pToAdd = category.adminPrograms.filter(p => p.id === addedItemId)
            if (pToAdd.length > 0) {
              let programToAdd = pToAdd[0]
              programToAdd.exercises.map(ex => (
                addSingleExercise(ex, programToAdd.programName)
              ));
              saveUserProgram(newUserPrograms)
            } else {
              return [];
            }
            return null
          })

        }
      }
    }
  }

  const deleteUserProgram = (deletedItemId) => {
    const newUserPrograms = userPrograms && userPrograms.filter((prog) => prog.splitCategory !== deletedItemId && prog.id !== deletedItemId)
    saveUserProgram(newUserPrograms)
  }

  const newUserExercise = (exercise) => {
    var newUserPrograms = Object.assign([], userPrograms.filter((p) => p.name !== ''))
    newUserPrograms.push(exercise);
    saveUserProgram(newUserPrograms)
  }

  const editUserExercise = (exercise) => {
    var newUserPrograms = Object.assign([], userPrograms.filter(p => p.id !== exercise.id))
    newUserPrograms.push(exercise);
    saveUserProgram(newUserPrograms)
  }

  const pasteUserExercise = (copiedExercise, pasteInFolder) => {
    if (copiedExercise) {
      var pasteExercise = Object.assign({}, copiedExercise)
      pasteExercise.splitCategory = pasteInFolder
      var newUserPrograms = Object.assign([], userPrograms)
      newUserPrograms.push(pasteExercise)
      saveUserProgram(newUserPrograms)     
    }
  }

  const reorderProgram = (newTree) => {
    sortedTreeData = Object.assign([], newTree)
    saveUserProgram(userPrograms, true)
  }

  return { addUserProgram, deleteUserProgram, newUserExercise, reorderProgram, editUserExercise, pasteUserExercise }

}